// extracted by mini-css-extract-plugin
export default {"promotionNew":"homeStyles_promotionNew__8mhOK","image_cont":"homeStyles_image_cont__NmRHy"};